import { defineMessages } from 'react-intl';

export const scope = 'loop.containers.ResetPassword';

export default defineMessages({
  Header: {
    id: `${scope}.header`,
    defaultMessage: 'Unesi novu lozinku',
  },
  Text: {
    id: `${scope}.text`,
    defaultMessage: 'Upiši svoju email adresu i novu lozinku.',
  },
  TextPhone: {
    id: `${scope}.textPhone`,
    defaultMessage: 'Upiši svoj broj telefona i novu lozinku.',
  },
  Button: {
    id: `${scope}.buttton`,
    defaultMessage: 'Promeni lozinku',
  },
  OrText: {
    id: `${scope}.orText`,
    defaultMessage: 'ili',
  },
  RegisterUser: {
    id: `${scope}.registerUser`,
    defaultMessage: 'Kreiraj nalog',
  },
});
